type ItemToNormalize = { id: string } & any

export const normalize = (arrayToNormalize: ItemToNormalize[], id?: string) => {
    return arrayToNormalize.reduce((collector: { [key: string]: ItemToNormalize }, item) => {
        collector[item[id || 'id']] = { ...item }
        return collector
    }, {})
}
